import PassagesList from "./PassagesList";

export default PassagesList;
